import React from "react";

const B1Flexibility = () => {
  return (
    <div className="b1FlexContainer">
      <h1>
        B1 <span>German Classes</span> in Bangalore: Elevate Your Language
        Proficiency with Prizma Academy
      </h1>
      <p>
        If you have completed the A1 and A2 levels of German and are looking to
        further enhance your proficiency, Prizma Academy’s B1 German Classes in
        Bangalore are the perfect next step. Our B1 German Classes in Bangalore
        are designed to build on your existing knowledge and help you achieve
        greater fluency and confidence in the language. Here’s why Prizma
        Academy is the ideal choice for advancing your German language skills.
      </p>
    </div>
  );
};

export default B1Flexibility;
